import { ROUTE_MANAGER_V3 } from 'settings/constants/tenantSettings'

import { useTenantSetting } from './useTenantSetting'

/**
 * Gates the route_slot-keyed (v3) route manager behind the `routeManagerV3` tenant
 * setting. False while it loads, so no tenant reaches a v3 endpoint before it resolves.
 */
export const useRouteManagerV3 = (): boolean => {
  const { value } = useTenantSetting(ROUTE_MANAGER_V3) as { value: string | undefined }
  return typeof value === 'string' && value.toLowerCase() === 'true'
}
